<template>
    <v-content style="padding-top: 0px !important;height:60px;">
        <v-fade-transition mode="out-in">
            <router-view />
        </v-fade-transition>
        <!-- <NotificationRevision ref='notification'></NotificationRevision> -->
        <Snackbar />
        <NotificationRevision ref="notification"></NotificationRevision>
    </v-content>
</template>

<script>
import Snackbar from "@/components/helper/Snackbar.vue";
import NotificationRevision from "@/views/strategy/components/NotificationRevision";
// import NotificationRevision from "@/components/NotificationRevision";

export default {
    metaInfo() {
        return {
            title: "QuiteJá estratégias",
        };
    },
    components: {
        Snackbar,
        NotificationRevision,
        // NotificationRevision
    },
};
</script>

<style>
#core-view {
    padding-bottom: 0px;
}
</style>
